import React from 'react';
import { Form, Spinner } from 'react-bootstrap';

import { useFetchMondayColumns } from '../../../../services/supportAdmin';

const MondayColumnSelector = ({
  boardId,
  value,
  onChange,
  filterTypes = null,
  placeholder = 'Select a column...',
  disabled = false,
  showItemNameOption = false,
}) => {
  const { isLoading, data, error } = useFetchMondayColumns(boardId, {
    enabled: !!boardId,
  });

  if (!boardId) {
    return (
      <Form.Select disabled>
        <option>Select a board first</option>
      </Form.Select>
    );
  }

  if (isLoading) {
    return (
      <div className="d-flex align-items-center">
        <Spinner animation="border" size="sm" className="me-2" />
        <span className="text-muted">Loading columns...</span>
      </div>
    );
  }

  if (error) {
    return (
      <Form.Select disabled className="text-danger">
        <option>Error loading columns</option>
      </Form.Select>
    );
  }

  let columns = data?.columns || [];

  // Filter by column types if specified
  if (filterTypes && filterTypes.length > 0) {
    columns = columns.filter((col) => filterTypes.includes(col.type));
  }

  const handleChange = (e) => {
    const columnId = e.target.value;
    if (columnId === '__item_name__') {
      onChange(columnId, 'item_name');
      return;
    }
    const column = columns.find((c) => c.id === columnId);
    // Pass both columnId and columnType to parent
    onChange(columnId, column?.type || '');
  };

  return (
    <Form.Select
      value={value || ''}
      onChange={handleChange}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {showItemNameOption && (
        <option value="__item_name__">Item Name (first column)</option>
      )}
      {columns.map((column) => (
        <option key={column.id} value={column.id}>
          {column.title} ({column.type})
        </option>
      ))}
    </Form.Select>
  );
};

export default MondayColumnSelector;
